import { Flex } from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  useGet3thPartyServices,
  useGetOneService,
} from "shared/api/requests/services";
import Field from "shared/components/form/Field";
import TextField from "shared/components/form/TextField";
import { CreateMessageFormT } from "shared/form-values/dialog_messages";
import { PathsParams, PathsE, ModuleE } from "shared/routes";

const Form = () => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<CreateMessageFormT>();
  const { serviceId } = useParams<PathsParams[PathsE.ACTORS]>();
  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined,
  });


  const { useGetServiceModule } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.ACTORS,
  });

  return (
    <Flex gap="20px" direction="column" w="100%">
      <Field
        type="async-select"
        name="clientID"
        label={t("forms.client")}
        required
        fullWidth
        placeholder={t("forms.selectClient")}
        optionsQuery={useGetServiceModule}
        labelName="name"
        valueName="id"
        onChange={(value) => {
          setValue("clientName", value?.name || "");
          setValue("clientID", value?.id || null);
        }}
        renderOptionLabel={(option) => `${option.id} – ${option.name}`}
        defaultValue={null}

      />
      <TextField<CreateMessageFormT>
        name="text"
        label="Text"
        required
        textarea
        rows={8}
      />
      <Field
        type="select"
        name="position"
        label={t("forms.position")}
        options={[
          { value: "End", label: "End" },
          { value: "Start", label: "Start" },
        ]}
      />
    </Flex>
  );
};

export default Form;
